import { bridge, loader, native, webviewInfo } from '@ali/amap-lib';
import CONFIG_URLS from '../../config/config.aos';
import CONFIG_ACT from '../../config/config.act';
import AesMonitor from './monitor';

const myLoader = (() => {
  const requestHandler = loader;

  return (method = 'get', url, params) => {
    const isInAmap = webviewInfo.isInAmap();
    const requestStartTime = +new Date();


    if (!url) {
      return Promise.reject(new Error('请求地址不存在.'));
    }

    return new Promise((resolve, reject) => {
      let handler = requestHandler.aosJsonp;
      if (isInAmap) {
        handler = requestHandler[method];
        method = () => { };
      }
      handler(
        url,
        params,
        (response) => {
          console.log('[AOS请求] ', url, params);
          console.log('[AOS响应] ', response);
          const requestEndTime = +new Date();
          const duration = requestEndTime - requestStartTime;
          AesMonitor.sendApi({
            url,
            params,
            response,
            method,
            duration,
            success:
              response &&
              response.code &&
              parseInt(response.code.toString(), 10) === 1,
          });
          if (
            response &&
            response.code &&
            parseInt(response.code.toString(), 10) === 1
          ) {
            const { data } = response;
            const { timestamp } = response;

            // 派发时间
            if (timestamp && CustomEvent) {
              const myEvent = new CustomEvent('serverTimeUpdate', {
                detail: {
                  timestamp: parseInt(timestamp, 10),
                },
              });

              window.dispatchEvent(myEvent);
            }
            resolve(data);
            // 全链路日志，记录埋点
            const logParamInfo = {
              action: 'amapLog',
              level: 'info',
              group: 'basemap.activity',
              tag: CONFIG_ACT.name,
              msg: JSON.stringify({
                url,
                params,
                res: 200,
              }),
            };
            // console.log('[全链路日志] ', logParamInfo);
            bridge.send(logParamInfo);
          } else {
            reject(response);
            // 全链路日志，记录埋点
            const logParamError = {
              action: 'amapLog',
              level: 'error',
              group: 'basemap.activity',
              tag: CONFIG_ACT.name,
              msg: JSON.stringify({
                url,
                params,
                res: response && response.code,
                errMsg: JSON.stringify(response.message || response.data),
              }),
            };
            // console.log('[全链路日志] ', logParamError);
            bridge.send(logParamError);
          }
        },
        method,
        false,
        true,
        {
          asac: '2A20813HP80BQ7Z8BXOG7O',
        }
      );
    });
  };
})();

const sign = 1;

const service = {
  /**
   * 获取 user id
   * @returns {Promise<any>}
   */
  getUserId(onlyGetId = false, needRelogin = false) {
    return new Promise((resolve, reject) => {
      native.getUserId(
        (data) => {
          AesMonitor.sendApi({
            url: 'getAmapUserId',
            params: {
              action: "getAmapUserId",
              onlyGetId: Number(onlyGetId),
              needRelogin: Number(needRelogin),
            },
            response: data,
            method: 'get',
            duration: 0,
            success: true
          });
          const userId = data.userid;
          if (!userId) {
            reject(data);
          } else {
            resolve(userId);
          }
        },
        onlyGetId,
        needRelogin
      );
    });
  },
  /**
   * 获取用户所在地的adcode
   * @returns {Promise<any>}
   */
  getMapLocation() {
    return new Promise((resolve, reject) => {
      native.getMapLocation((data) => {
        AesMonitor.sendApi({
          url: 'getMapLocation',
          params: {
            action: "getMapLocation",
          },
          response: data,
          method: 'get',
          duration: 0,
          success: true
        });
        const adCode = data.adcode || '';
        if (adCode) {
          resolve(adCode);
        } else {
          reject();
        }
      });
    });
  },
  /**
   * 获取 getMapLocation
   * @returns {Promise<any>}
   */
  getMapLocationNew() {
    return new Promise((resolve) => {
      var param = {
        action: 'getMapLocation',
        forceReturnValue: '1'
      };
      bridge.send(param, (location) => {
        console.log('[location]', location);
        AesMonitor.sendApi({
          url: 'getMapLocation',
          params: {
            action: "getMapLocation",
            forceReturnValue: '1'
          },
          response: location,
          method: 'get',
          duration: 0,
          success: true
        });
        resolve(location);
      });
    });
  },
  /**
   * 获取 tid
   * @returns {Promise<any>}
   */
  getAppInfo() {
    return new Promise((resolve, reject) => {
      native.getAppInfo((data) => {
        AesMonitor.sendApi({
          url: 'getExtraUrl',
          params: {
            action: "getExtraUrl",
          },
          response: data,
          method: 'get',
          duration: 0,
          success: true
        });
        // 添加 data 为空的判断
        if (data && data.tid) {
          const { tid } = data;
          resolve(tid);
        } else {
          reject(data);
        }
      });
    });
  },
  /**
   * 获取app的
   * @returns {Promise<any>}
   */
  compareAppVersion(version = '080900') {
    return new Promise((resolve) => {
      native.compareDiv(version, (res) => {
        AesMonitor.sendApi({
          url: 'compareDiv',
          params: {
            version
          },
          response: res,
          method: 'get',
          duration: 0,
          success: true
        });
        resolve(res);
      });
    });
  },
  /**
   * 首页主接口
   * @param tid
   * @returns {*}
   */
  index(tid, diu) {
    return myLoader('post', CONFIG_URLS.index, [
      { tid, sign },
      {
        diu,
        sign,
      },
    ]);
  },
  rule() {
    return myLoader('post', CONFIG_URLS.rule, [
      { activity: CONFIG_ACT.activity, sign },
    ]);
  },
  /**
   * 领取奖励
   * @param tid
   * @returns {*}
   */
  draw(tid, adcode) {
    return myLoader('post', CONFIG_URLS.draw, [
      {
        tid,
        sign,
      },
      {
        adcode,
      },
    ]);
  },

  /**
   * 我的口袋
   * @param tid
   * @returns {*}
   */
  treasure(tid) {
    return myLoader('post', CONFIG_URLS.treasure, [
      {
        tid,
        sign,
      },
    ]);
  },

  /**
   * 好友列表
   */
  friendList(tid, more = 0) {
    return myLoader('post', CONFIG_URLS.friendlist, [
      {
        tid,
        sign,
      },
      {
        more,
      },
    ]);
  },
  /**
   * 邀请回调
   * @param tid
   * @param friend_token
   * @param guard_code
   * @param share_type
   * @returns {*}
   */
  callback(tid, friend_token, guard_code) {
    return myLoader('post', CONFIG_URLS.callback, [
      {
        tid,
        sign,
      },
      {
        friend_token,
      },
      {
        guard_code,
      },
    ]);
  },
  /**
   * 邀请好友端外
   * @param tid
   * @returns {*}
   */
  invite(tid) {
    return myLoader('post', CONFIG_URLS.invite, [
      {
        tid,
        sign,
      },
    ]);
  },

  /**
   * 邀请好友端内
   * @param tid
   * @param friend_uid
   * @param stage_id
   * @param source
   * @returns {*}
   */
  inviteApp(tid, activity, friend_uid) {
    return myLoader('post', CONFIG_URLS.inviteApp, [
      {
        tid,
        sign,
      },
      {
        activity,
      },
      {
        friend_uid,
      },
      {
        scene: 1,
      },
    ]);
  },

  /**
   *口令分享配置
   */
  shareCommand(tid, biz_param) {
    return myLoader('post', CONFIG_URLS.share_command, [
      {
        tid,
        sign,
      },
      {
        source: CONFIG_ACT.activity,
        sign,
      },
      {
        biz_param,
      },
    ]);
  },
  /**
   *长链接转短链接
   */
  transform(address) {
    const params = [
      {
        flag: 1,
        sign,
      },
      {
        address,
        sign,
      },
      {
        appfrom: 'operation',
      },
    ];
    return new Promise((resolve, reject) => {
      loader.post(
        CONFIG_URLS.transform,
        params,
        (res) => {
          if (+res.code === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        false,
        false
      );
    });
  },
  shareConf(tid, with_user = 0) {
    return myLoader('post', CONFIG_URLS.share_conf, [
      {
        tid,
        sign,
      },
      {
        activity: CONFIG_ACT.activity,
      },
      {
        with_user,
      },
    ]);
  },
  /**
   *base64生成在线地址
   */
  createImage(tid, image_data) {
    return myLoader('post', CONFIG_URLS.create_image, [
      {
        tid,
        sign,
      },
      {
        image_data,
      },
    ]);
  },
  /**
   * 800 元填写信息提现页面
   * @param tid tid
   * @param username 姓名
   * @param identify 身份证
   */
  certifySubmit(tid, username, identity) {
    return myLoader('post', CONFIG_URLS.certify_submit, [
      {
        tid,
        sign,
      },
      {
        username,
      },
      {
        identity,
      },
    ]);
  },
  /**
   * 提现接口
   * @param tid
   * @param activity
   * tid,活动标识
   */
  ownerCashToWallet(tid, activity) {
    return myLoader('post', CONFIG_URLS.owner_cash_to_wallet, [
      {
        tid,
        sign,
      },
      {
        activity,
      },
    ]);
  },
  /**
   * 设置SP/UserDefault的文件存储
   */
  setLocalStorage(value) {
    return new Promise((resolve) => {
      bridge.send(
        {
          action: 'setLocalStorage',
          namespace: 'new_message_box_page_namespace',
          key: 'feed_list_message_read',
          value: JSON.stringify(value),
        },
        (res) => {
          AesMonitor.sendApi({
            url: 'setLocalStorage',
            params: {
              action: 'setLocalStorage',
              namespace: 'new_message_box_page_namespace',
              key: 'feed_list_message_read',
              value: JSON.stringify(value),
            },
            response: res,
            method: 'get',
            duration: 0,
            success: true
          });
          console.log(res, 'setLocalStorage'); // 返回值
          resolve(res);
        }
      );
    });
  },
  /**
   * 获取SP/UserDefault的文件存储
   */
  getLocalStorage() {
    return new Promise((resolve) => {
      bridge.send(
        {
          action: 'getLocalStorage',
          namespace: 'new_message_box_page_namespace',
          key: 'feed_list_message_read',
        },
        (res) => {
          AesMonitor.sendApi({
            url: 'getLocalStorage',
            params: {
              action: 'getLocalStorage',
              namespace: 'new_message_box_page_namespace',
              key: 'feed_list_message_read',
            },
            response: res,
            method: 'get',
            duration: 0,
            success: true
          });
          console.log(res, 'getLocalStorage');
          resolve(res?.value || '');
        }
      );
    });
  },
};

/**
 * 向 service 内部注入函数
 * @param fn {function} 注入的函数
 * @param name {string}
 * @private
 */
service._install = (fn, name) => {
  let key = name || fn.name;
  if (typeof fn === 'function' && !service[key]) {
    service[key] = fn;
  }
};

/**
 *
 * @type {function(*=, *=, *=): (Promise<never>)}
 * @private
 */
service._loader = myLoader;
export default service;
